module.exports = __webpack_public_path__ + "static/img/sec1-cont-tit@m.bf51e92.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lgchem-history/sec1-cont-tit@m.png
// module id = x2nW
// module chunks = 0